// removed by extract-text-webpack-plugin
module.exports = {"nf-tooling-def-form":"nf-tooling-def-form","nf-rff-input-field__input":"nf-rff-input-field__input","nf-button":"nf-button","nf-rff-input-field__label":"nf-rff-input-field__label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/InventoryManagementDefinitionForm/InventoryManagementDefinitionForm.scss
// module id = 5308
// module chunks = 1